(() => {
  const root = document.querySelector("[data-nappi-listicle]");
  if (!root) return;
  const links = root.querySelectorAll("a[data-nappi-cta]");
  const incoming = new URLSearchParams(window.location.search);
  if ([...incoming.keys()].length) {
    links.forEach((link) => {
      try {
        const url = new URL(link.getAttribute("href"), window.location.origin);
        if (url.origin !== window.location.origin) return;
        incoming.forEach((value, key) => {
          if (!url.searchParams.has(key)) url.searchParams.set(key, value);
        });
        link.setAttribute("href", url.pathname + url.search + url.hash);
      } catch (error) {
      }
    });
  }
  if (window.HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports("speculationrules")) {
    const rules = document.createElement("script");
    rules.type = "speculationrules";
    rules.textContent = JSON.stringify({
      prefetch: [{ source: "document", where: { selector_matches: "a[data-nappi-cta]" }, eagerness: "moderate" }]
    });
    document.head.append(rules);
  }
  const hours = root.querySelectorAll("[data-nappi-countdown-h]");
  const minutes = root.querySelectorAll("[data-nappi-countdown-m]");
  const seconds = root.querySelectorAll("[data-nappi-countdown-s]");
  if (hours.length) {
    const match = /^([+-])(\d{2})(\d{2})$/.exec(root.dataset.tzOffset || "");
    const offsetMs = match ? (match[1] === "-" ? -1 : 1) * (Number(match[2]) * 60 + Number(match[3])) * 6e4 : 0;
    const cutoff = Math.min(Math.max(Number(root.dataset.cutoffHour) || 24, 1), 24);
    const pad = (n) => String(n).padStart(2, "0");
    const tick = () => {
      const now = Date.now();
      const shop = new Date(now + offsetMs);
      let target = Date.UTC(shop.getUTCFullYear(), shop.getUTCMonth(), shop.getUTCDate(), cutoff) - offsetMs;
      if (target <= now) target += 864e5;
      const left = Math.max(0, Math.floor((target - now) / 1e3));
      const h = pad(Math.floor(left / 3600));
      const m = pad(Math.floor(left % 3600 / 60));
      const s = pad(left % 60);
      hours.forEach((el) => {
        el.textContent = h;
      });
      minutes.forEach((el) => {
        el.textContent = m;
      });
      seconds.forEach((el) => {
        el.textContent = s;
      });
    };
    tick();
    window.setTimeout(() => {
      tick();
      window.setInterval(tick, 1e3);
    }, 1e3 - Date.now() % 1e3);
  }
  const pageName = window.location.pathname.split("/").filter(Boolean).pop() || "listicle";
  const track = (name, params) => window.NappiTrack ? window.NappiTrack(name, params) : (window.__nappiTrackQ = window.__nappiTrackQ || []).push([name, params]);
  links.forEach((link, index) => {
    link.addEventListener("click", () => {
      const position = link.classList.contains("nappi-listicle__cta--sticky") ? "sticky" : String(index + 1);
      track("ListicleCTA", { content_name: pageName, position });
    });
  });
  let halfRead = false;
  const watchRead = () => {
    const doc = document.documentElement;
    const scrollable = doc.scrollHeight - doc.clientHeight;
    if (halfRead || scrollable <= 0 || window.scrollY / scrollable < 0.5) return;
    halfRead = true;
    window.removeEventListener("scroll", watchRead);
    track("ListicleRead", { content_name: pageName, percent: 50 });
  };
  window.addEventListener("scroll", watchRead, { passive: true });
  const fill = root.querySelector("[data-nappi-listicle-progress]");
  const bar = root.querySelector("[data-nappi-listicle-sticky]");
  if (!fill && !bar) return;
  const SHOW_AFTER = 600;
  const END_GAP = 130;
  const update = () => {
    const doc = document.documentElement;
    const y = window.scrollY;
    const scrollable = doc.scrollHeight - doc.clientHeight;
    if (fill) {
      const read = scrollable > 0 ? Math.min(Math.max(y / scrollable, 0), 1) : 0;
      fill.style.width = `${read * 98}%`;
    }
    if (bar) {
      bar.classList.toggle("is-active", y >= SHOW_AFTER && y + window.innerHeight < doc.scrollHeight - END_GAP);
    }
  };
  window.addEventListener("scroll", update, { passive: true });
  window.addEventListener("resize", update);
  update();
})();
